// Other sum trigger
// Used to activate other sum input field if clicked.
// ----------------------------------------------------------------

import $ from 'jquery';

const donationOtherSumTrigger   = $('.js-donationOtherSumTrigger');
const donationOtherSumTarget    = $('.js-donationOtherSumTarget');
const donationOtherInput        = $('input[name="donation-amount-other"]')

export function donationOtherSumActive() {
    if (donationOtherSumTrigger.is(':checked')) {
        $(donationOtherSumTarget).show();
        $(donationOtherInput).prop('required', true);
    } else {
        $(donationOtherSumTarget).hide();
        $(donationOtherInput).prop('required', false);
    }
}
